import { TdsButton, TdsModal, TdsModalButtons } from '@trv-tds/react';
import React, { useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { GlobalContext } from '../../context/GlobalProvider';

const yesBtnTxt = 'Yes';
const noBtnTxt = 'No';
const yesBtnVal = 'yes';
const noBtnVal = 'no';

export default function CancelModal() {
    const {
        actions: { resetState }
    } = useContext(GlobalContext);
    const navigate = useNavigate();

    const cancelClick = ({ detail: returnValue }) => {
        if (returnValue === yesBtnVal) {
            resetState();
            navigate('/');
        }
    };

    return (
        <div className={'cancel-modal'}>
            <TdsModal
                id="cancel-modal"
                data-testid="cancel-modal"
                size="small"
                dialogTitle="Cancel Registration"
                onTdsClose={cancelClick}
            >
                <p id="cancel-modal-description">
                    The information you have entered so far will be lost. Are you sure you want to
                    proceed?
                </p>

                <TdsModalButtons slot="footer">
                    <TdsButton variant="primary" data-dismiss="modal" value={yesBtnVal}>
                        {yesBtnTxt}
                    </TdsButton>
                    <TdsButton variant="secondary" data-dismiss="modal" value={noBtnVal}>
                        {noBtnTxt}
                    </TdsButton>
                </TdsModalButtons>
            </TdsModal>
        </div>
    );
}
